module.exports = __webpack_public_path__ + "static/media/ship.a0737203.svg";